const Footer = (props) => {
  	return (
	    <div id="footer">
	    	<a href="https://github.com/Reach-Industries/Frontend-Test-2022">Reach-Industries - Frontend-Test-2022</a>
	    	<a href="mailto:a.ciardi@hotmail.it">Andrea Ciardi - a.ciardi@hotmail.it</a>
	    </div>
  	);
};

export default Footer;